import React from 'react';
import './TopActionBar.scss';
import { Col, Row } from 'antd';
import { DocumentationLinksDropdown } from '../DocumentationLinksDropdown';

export const TopActionBar = ({ children, showDocumentationLinksDropdown = false, documentationType }) => {
    return (
        <Row className="top-action-bar" justify={'space-between'}>
            <Col>{children}</Col>
            <Col>
                {showDocumentationLinksDropdown && <DocumentationLinksDropdown documentationType={documentationType} />}
            </Col>
        </Row>
    );
};
